import http from "../http-common";
import { AxiosResponse } from "axios";

export interface DemoSession {
  orderId: number;
  tableId: number;
  clientId: number;
  name: string;
  isDemo: boolean;
}

class DemoDataService {
  get(): Promise<AxiosResponse<DemoSession>> {
    return http.get<DemoSession>("/demo");
  }
}

const demoDataService = new DemoDataService();
export default demoDataService;
